<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="5">
                <el-input v-model="filter.ticketId"
                          :placeholder="$t('serviceTickets.ticketNumber')"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :span="9">
                <el-input v-model="filter.email"
                          placeholder="Email"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :span="4">
                <el-cascader class="selector" placeholder="Status" :options="options" change-on-select clearable @change="emailStatusFilter">
                </el-cascader>
            </el-col>
        </el-row>
        <el-table size="mini" :data="emails" @sort-change="sortChanged" v-loading="loading" class="orders-table tablewithshading">
            <el-table-column prop="serviceTicketId" label="Service Ticket Id"></el-table-column>
            <el-table-column prop="serviceCompanyName" label="Service Company"></el-table-column>
            <el-table-column prop="email" label="Email Address"></el-table-column>
            <el-table-column prop="subject" label="Subject"></el-table-column>
            <el-table-column prop="emailStatus" label="Status"></el-table-column>
            <el-table-column prop="createdDate" label="Created Date">
                <template slot-scope="scope">
                    {{scope.row.createdDate | datetime}}
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" width="200px">
                <template slot-scope="scope">
                    <el-button size="mini" @click="resend(scope.row.id)">
                        Resend
                    </el-button>
                    <el-button size="mini" @click="emailDetailsVisibleMethod(scope.row)">
                        Details
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <email-details-dialog :ticketId="ticketIdToShow"
                              :subject="subject"
                              :body="body"
                              :visible="emailDetailsVisible"
                              @dialogClosed="emailDetailsFinished"></email-details-dialog>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>

    </div>
</template>

<script>
    import Vue from "vue";
    import api from "../api";
    import EmailDetailsDialog from "./emailDetailsDialog";

    export default {
        name: "email-list",
        components: {
            EmailDetailsDialog
        },
        data() {
            return {
                options: [{ value: 0, label: 'Sent' }, { value: 1, label: 'Failed' }, { value: 2, label: 'Confirmed' }, { value: 3, label: 'Saved' }],
                emails: [],
                ticketIdToShow: null,
                subject: "",
                body: "",
                emailDetailsVisible: false,
                loading: true,
                dialogVisible: false,
                filter: {
                    ticketId: "",
                    email: "",
                    emailStatus: ""
                },
                sort: {},
                currentPage: 1,
                total: 0
            };
        },
        created() {
            this.loadEmails();
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    this.loadEmails();
                }
            }
        },
        methods: {
            emailStatusFilter(val) {
                if (val.length > 0)
                    this.filter.emailStatus = val[0];
                else
                    this.filter.emailStatus = null;
                this.loadEmails();

            },
            emailDetailsVisibleMethod(val) {
                console.log(val);
                this.ticketIdToShow = val.serviceTicketId;
                this.subject = val.subject;
                this.body = val.body;
                this.emailDetailsVisible = true;
                console.log(this.emailDetailsVisible)
            },
            emailDetailsFinished() {
                this.ticketIdToShow = null;
                this.emailDetailsVisible = false;
                this.subject = "";
                this.body = "";
            },
            sortChanged(sort) {
                this.sort = sort;
                if (this.currentPage === 1) {
                    this.loadCustomers();
                } else {
                    this.currentPage = 1;
                }
            },
            loadEmails() {
                this.loading = true;
                api
                    .getEmails(
                        this.currentPage,
                        this.filter,
                        this.sort
                    )
                    .then(response => {
                        this.loading = false;
                        this.emails = response.data.items;
                        this.total = response.data.total;
                    });
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadEmails();
            },
            resend(id) {
                this.loading = true
                api.resend(id)
                    .then(response => {
                        this.loading = false;
                        if (response.data) {
                            this.$message({
                                title: this.$t('common.success'),
                                message: "Email sent",
                                type: "success"
                            });
                        } else {
                            this.$message.error("Failed to sent Email");
                        }
                    });
            }
        }
    };
</script>
<style scoped>
    .selector {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/emails/components/EmailsList.vue